// External Dependencies:
import React from 'react'

class MapMarker extends React.Component {
	render() {
		const { onClick, onMouseOver, selectedMarker, lat, lng } = this.props
		let classNameWrap = 'bubble-marker-wrap'
		let className = 'bubble-marker'

		if ( selectedMarker.lat == lat && selectedMarker.lng == lng ) {
			classNameWrap += ' is-active'
		}

		return (
			<div className={ classNameWrap } onClick={ onClick } onMouseOver={ onMouseOver }>
				<div className={ className }>
					<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="-901.9 495.4 55.8 67.3"><path d="M-846.1 523.1c-.1-7.4-3-14.3-8.2-19.5-5.3-5.3-12.3-8.2-19.7-8.2-7.5 0-14.5 2.9-19.7 8.2-5.3 5.3-8.2 12.3-8.2 19.7 0 7.4 2.9 14.4 8.2 19.7l19.7 19.7 19.5-19.5.1-.1c0-.1.1-.1.1-.1l.1-.1.1-.1 1-1.1c4.6-5.2 7.1-11.7 7-18.6z"/><circle cx="-874" cy="523.7" r="15.3"/></svg>
				</div>
			</div>
		)
	}
}

export default MapMarker



// WEBPACK FOOTER //
// ./components/Map/MapMarker.jsx